import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SectionTitle } from '../../components/typography/Heading';
import { fetchNewestProjectsForEvent } from '../../project/project-actions';
import styles from './p3aksjonen.module.less';
import ProjectFlatCard from './project-flat-card-with-countdown/ProjectFlatCard';
import { Link } from 'react-router';

export const P3NewProjects = ({ p3aEventId, link, linkText }) => {
    const dispatch = useDispatch();
    const newestProjectIds = useSelector((state) => state.events.projectIdsNewest);

    useEffect(() => {
        dispatch(fetchNewestProjectsForEvent({ eventId: p3aEventId, limit: 5 }));
    }, [p3aEventId]);

    return (
        <section className={styles.challengeTopContainer}>
            <SectionTitle className={styles.subHeader}>Nyeste spleiser ⏳</SectionTitle>
            <div className={styles.topListContainer}>
                {newestProjectIds?.map((id) => (
                    <ProjectFlatCard
                        key={id}
                        projectId={id}
                        category={'new-project-p3aksjonen'}
                        action={'click'}
                        properties={{ 'project-id': id }}
                    />
                ))}
            </div>
            {link && linkText && (
                <Link to={link} className={styles.linkText}>
                    {linkText}
                </Link>
            )}
        </section>
    );
};
